
import { Component, Prop, Watch } from 'vue-property-decorator'
import { Mixins } from 'vue-mixin-decorator'
import MixinInterface from '@/_mixins/index'
import ProjectMixin from '@/_mixins/project'

import draggable from 'vuedraggable'
import Attachment from '@/_components/image/attachment.vue'
import EditorViewer from '@/_components/editorJS/viewer/viewer.vue'
import DialogTemplate from '@/_components/dialog/template/template.vue'
import AddButton from '@/_components/button/add/add.vue'
import { initDialog } from '@/utils/dialog'
import { deserialise } from 'kitsu-core'
import DeleteHseDocumentDialog from '@/views/Project/Settings/views/Hse/dialogs/deleteDocument.vue'

@Component({
    components: { draggable, Attachment, EditorViewer, DialogTemplate, AddButton },
    mixins: [ProjectMixin],
})
export default class HseDocumentsSettings extends Mixins<MixinInterface>(ProjectMixin) {
    get writable() {
        return this.currentProject
            ? this.currentProject.attributes.constraints.hseDocuments.writable
            : false
    }

    // DOCUMENTS
    loadingDocuments = false
    documents: Array<any> = []

    @Watch('currentProjectId', { immediate: true })
    async watchActiveProject() {
        if (this.currentProjectId) {
            await this.getHSEDocuments()
        }
    }

    async getHSEDocuments() {
        this.loadingDocuments = true
        let url = this.$store.getters.project(this.currentProjectId).relationships.hseDocuments
            .links.related

        this.documents = await this.getGeneralRequest(url).catch(() => {
            this.loadingDocuments = false
        })

        let hseDocuments: any = {}
        this.documents.forEach((item: any) => {
            hseDocuments[item.id] = item
        })
        this.$store.commit('hseDocuments', { ...this.$store.getters.hseDocuments, ...hseDocuments })
        this.loadingDocuments = false
    }

    // ADD DOCUMENT
    postDocument(data: any) {
        this.documents.push(data)
    }

    // UPDATE DOCUMENT
    updateLoading = false

    async updateOrder(value: any) {
        this.updateLoading = true
        let params = {
            updatedAt: this.$store.getters.hseDocument(value.moved.element.id).attributes.updatedAt,
            data: {
                id: value.moved.element.id,
                type: value.moved.element.type,
                attributes: {
                    index: value.moved.newIndex,
                },
            },
        }

        await this.patchHSEDocument(params).catch(() => {
            this.updateLoading = false
        })

        this.updateLoading = false
    }

    navigateToContact(id: string) {
        this.$router.push({
            name: 'hse-edit-document',
            params: { projectId: this.$route.params.projectId, hseDocumentId: id },
        })
    }

    // DELETE CONTACT
    document: any = null
    index: any = null
    isArchiveDocumentConfirmationDialogOpen = false
    isArchiving = false

    async initDelete(document: any, index: number) {
        let res = await initDialog(DeleteHseDocumentDialog, {
            hseDocument: deserialise({ data: this.lodash.cloneDeep(document) }).data,
        })
        if (res) {
            this.documents.splice(index, 1)
        }
    }

    confirmToArchive(document: any, index: number) {
        this.document = document
        this.index = index
        this.isArchiveDocumentConfirmationDialogOpen = true
    }

    async archiveDocument() {
        this.isArchiving = true
        await this.patchHSEDocument({
            data: {
                id: this.document.id,
                type: 'hseDocument',
                attributes: {
                    isArchived: !this.document.attributes.isArchived,
                },
            },
            updatedAt: new Date().toUTCString(),
        })
        this.isArchiveDocumentConfirmationDialogOpen = false
        this.document.attributes.isArchived = !this.document.attributes.isArchived
        this.isArchiving = false
    }
}
